<template>
    <div style="background-color: #004e9c;">
        <div class="container">
            <div class="row py-4 align-items-center">
                <div class="col-sm-6 text-white">
                    <img src="../../public/img/profile.png" width="60px" height="60px" >
                    <h5 class="mx-3 d-inline">{{ name }}</h5>
                </div>
                <div class="col-sm-6 text-start">
                    <button style="border: none;background-color: white;border-radius: 8px;color: #004e9c;"
                    class="px-4 py-2 mx-2" @click="gotohome()">صفحه اصلی</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-5">
        <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link px-5 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Home</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link px-5" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Profile</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent" style="background-color: #f5f5f5;">
          <div class="tab-pane fade container mt-4 show active text-center" id="home" role="tabpanel" aria-labelledby="home-tab" style="min-height: 40vh;">
            <!-- <img src="../../public/img/empty.png" class="w-50 my-5" alt=""> -->
            <table class="table bg-white">
              <thead>
                <tr>
                  <th scope="col">Position</th>
                  <th scope="col">Entry Price</th>
                  <th scope="col">Order Qty</th>
                  <th scope="col">UnRealized P&L</th>
                  <th scope="col">TP/SL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                </tr>
                <!-- <tr>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <td>Larry the Bird</td>
                  <td>Larry the Bird</td>
                  <td>@twitter</td>
                </tr> -->
              </tbody>
            </table>
            <div class="bg-white my-4 row col-4 mx-auto py-2">
              <h5>no signal</h5>
            </div>
          </div>
          <div class="tab-pane fade container mt-4" id="profile" role="tabpanel" aria-labelledby="profile-tab" style="min-height: 40vh;">
            <div class="row">
                <div class="col-md-6">
                    <div class="card text-start">
                      <h5>TRADING HISTORY</h5>
                      <!-- <img src="../../public/img/empty.png" class="w-75 mx-auto my-4" alt=""> -->
                        <VueApexCharts type="pie" height="350" :options="chartOptions1" :series="series1"></VueApexCharts>
                    </div>
                </div>
                <div class="col-md-6 mt-md-0 mt-4">
                    <div class="card text-start">
                      <h5>EARNINGS</h5>
                      <!-- <img src="../../public/img/empty.png" class="w-75 mx-auto my-4" alt=""> -->
                        <VueApexCharts type="bar" height="350" :options="chartOptions2" :series="series2"></VueApexCharts>
                    </div>
                </div>
                <div class="col-md-4 mt-4">
                  <div class="card">
                    <div class="row text-start">
                      <h5 class="mb-3">7 Days Statistics</h5>
                      
                      <div class="col-6 text-end">
                        0
                        <br>
                        <br>
                        0
                        <br>
                        <br>
                        0
                        <br>
                        <br>
                        0
                        <br>
                        <br>
                        0
                      </div>
                      <div class="col-6 text-start">
                        : total trades
                        <br>
                        <br>
                        : win trades
                        <br>
                        <br>
                        : lose trades
                        <br>
                        <br>
                        : win rate
                        <br>
                        <br>
                        : ROI
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 mt-4">
                    <div class="card text-start">
                      <h5>PROFIT</h5>
                      <!-- <img src="../../public/img/empty.png" class="w-50 mx-auto my-4" alt=""> -->
                        <VueApexCharts type="line" height="350" :options="chartOptions3" :series="series3"></VueApexCharts>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import VueApexCharts from "vue3-apexcharts";

 export default defineComponent({
    components:{VueApexCharts},
    setup() {
      const router = useRouter()
      const name = localStorage.getItem('name') +' ' + localStorage.getItem('family');
        const series1 = ref()
        series1.value =  [100];
        const chartOptions1 = ref();
        chartOptions1.value = {
          chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['USDT'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          }

          const series2 = ref()
          series2.value =  [0,0,0,0,0,0,0,0,0,0,0,0];
          const chartOptions2 = ref();
          chartOptions2.value = {
            plotOptions: {
              bar: {
                columnWidth: '45%',
                distributed: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            legend: {
              show: false
            },
            xaxis: {
              categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              labels: {
                style: {
                  fontSize: '12px'
                }
              }
            }
            }

            const series3 = ref()
          series3.value =  [{
            name: "Session Duration",
            data: []
          }];
          const chartOptions3 = ref();
          chartOptions3.value = {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: [5, 7, 5],
              curve: 'straight',
              dashArray: [0, 8, 5]
            },
            legend: {
              tooltipHoverFormatter: function(val, opts) {
                return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
              }
            },
            markers: {
              size: 0,
              hover: {
                sizeOffset: 6
              }
            },
            xaxis: {
              categories: ['01 Jan', '02 Jan', '03 Jan', '04 Jan', '05 Jan', '06 Jan', '07 Jan', '08 Jan', '09 Jan',
                '10 Jan', '11 Jan', '12 Jan'
              ],
            },
            tooltip: {
              y: [
                {
                  title: {
                    formatter: function (val) {
                      return val + " (mins)"
                    }
                  }
                },
                {
                  title: {
                    formatter: function (val) {
                      return val + " per session"
                    }
                  }
                },
                {
                  title: {
                    formatter: function (val) {
                      return val;
                    }
                  }
                }
              ]
            },
            grid: {
              borderColor: '#f1f1f1',
            }
            }

            function logout(){
              localStorage.removeItem('name')
              localStorage.removeItem('id')
              localStorage.removeItem('family')
              localStorage.removeItem('phone')
              router.push({name:'sign-in'})
            }

            function gotohome(){
              router.push({name:'home'})
            }

        return {
            series1,
            series2,
            series3,
            router,
            name,
            chartOptions1,
            chartOptions2,
            chartOptions3,
            logout,
            gotohome
        }
    }
 })
</script>
<style scoped>
*{
  direction: rtl;
}
</style>